import React, { useEffect, useRef, useState } from 'react';
import { ArrowCircleLeft2, MessageText1 } from 'iconsax-react';
import { ReactComponent as Bed } from '../../Assets/Icons/bedcardIcon.svg';
import { ReactComponent as Shower } from '../../Assets/Icons/ShowerIcon.svg';
import { ReactComponent as Toilet } from '../../Assets/Icons/toiletIcon.svg';
import { ReactComponent as PropertyOverview } from '../../Assets/Icons/propertyOverview.svg';
import Support from '../../Assets/Icons/support.png';
import { useLocation, useNavigate } from 'react-router-dom';
import BuyProperty from '../../Components/Wallet/BuyProperty';
import { useSingleProperty } from '../../Services/hooks/SingleProperty';
import { PageLoader } from '../../Components/Loader/pageLoader';
import { formatCurrency } from '../../Utils/currencyFormat';
import ContactUs from '../../Components/Modal/contactUs';
import BookInspection from '../../Components/Modal/bookInspection';
import { StorageBaseURL } from '../../Services/constant/Action';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { userData } from '../../Storeredux/constants/actionTypes';
import RentAssist from '../../Components/Modal/RentAssist';
import PaymentFrame from '../../Components/Modal/PaymentFrame';

function Viewproperty() {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isInspectionOpen, setIsInspectionOpen] = useState<boolean>(false);
  const [isRentAssistOpen, setIsRentAssistOpen] = useState<boolean>(false);
  const [isPaymentFrameOpen, setIsPaymentFrameOpen] = useState<boolean>(false);
  const [link, setLink] = useState<string>('');
  const datata = useRef();
  const navigate = useNavigate();
  const location = useLocation();
  let pageName = location.pathname;
  pageName = pageName.split('/').pop() || '';
  const { getSinglePropertyData, loading: pageLoading, propertyDetails } = useSingleProperty();
  console.log(propertyDetails?.property);

  const [buy, setBuy] = useState(false);
  const buySlot = async () => {
    if (propertyDetails?.inspection_status === 'active') {
      await setIsRentAssistOpen(true);
      return;
    } else if (propertyDetails?.inspection_status === 'none') {
      setIsInspectionOpen(true);
      return;
    } else {
      return null;
    }
  };

  const onHideBookInspection = async () => {
    setIsInspectionOpen(false);
    const payload = {
      user_id: user.id,
    };
    await getSinglePropertyData(pageName, payload);
  };

  const getFrameLink = (paymentLink: string) => {
    setLink(paymentLink);
    setIsPaymentFrameOpen(true);
  };

  const getButtonName = (status: string) => {
    switch (status) {
      case 'none':
        return 'Schedule Inspection';
      case 'pending':
        return 'Awaiting Approval';
      case 'active':
        return 'Request Rent Assist';
    }
  };

  const isValidHttpsUrl = (url: string) => {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'https:';
    } catch (errors: any) {
      console.log(errors);
      return false; // If it's not a valid URL, return false
    }
  };

  useEffect(() => {
    const payload = {
      user_id: user.id,
    };
    getSinglePropertyData(pageName, payload);
  }, []);
  return (
    <div className='py-10'>
      {!buy ? <div className='w-11/12 mx-auto'>
          <div className='flex items-center gap-2 py-4 cursor-pointer'>
            <ArrowCircleLeft2 size="42" variant="Bold" color="#20996B" onClick={() => navigate(-1)}/>
          </div>
          <div className='rounded-3xl mx-auto py-6'>
            {
              pageLoading ?
                <div className='gap-7 w-fit justify-center mx-auto mt-7 flex flex-wrap h-52'>
                  <PageLoader/>
                </div>
                :
                <>
                  <div className={'flex flex-col gap-y-5'}>
                    <div className={'flex lg:flex-row flex-col items-center gap-5'}>
                      <div className={'lg:w-1/2 w-full'}>
                        <img src={isValidHttpsUrl(propertyDetails?.property?.thumbnail) ? propertyDetails?.property?.thumbnail : `${StorageBaseURL}${propertyDetails?.property?.thumbnail}`}  alt='property' className={'w-full bg-green-200 rounded-xl'}
                             style={{ height: '27rem' }}/>
                      </div>
                      <div className={'lg:w-1/2 w-full'}>
                        <div className='flex w-full flex-row flex-wrap gap-5 justify-center overflow-hidden img'>
                          {
                            propertyDetails?.property?.image?.slice(0, 4).map((imagePath: any, index: number) => {
                              return (
                                <img key={index} src={isValidHttpsUrl(imagePath.image) ? imagePath.image : `${StorageBaseURL}${imagePath.image}`} alt='placeholder'
                                     className='max-w-30% max-h-30% xl:w-[48%] w-[20%] lg:max-w-[35%] xl:h-[13rem] lg:h-[10rem] rounded-xl'/>
                              );
                            })
                          }
                        </div>
                      </div>
                    </div>
                    <div className={'flex md:flex-row flex-col justify-between gap-5'}>
                      <div className={'md:w-[65%] w-full rounded-2xl bg-white px-5 p-4 pb-12'}>
                        <h1 className=' text-lg lg:text-2xl font-bold py-4'>
                          {propertyDetails?.property?.title}
                        </h1>
                        <div className='p-3 pb-4 pl-0 flex flex-col gap-y-3'>
                          <div className={'flex gap-2 '}>
                          <span
                            className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Bed/>
                            </span>
                            <span>{propertyDetails?.property?.rooms}</span>
                          </span>
                            <span
                              className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Shower/>
                            </span>
                            <span>{propertyDetails?.property?.showers}</span>
                          </span>
                            <span
                              className={'bg-custom-grey flex justify-between gap-3 py-1 px-2.5 w-fit rounded-3xl items-center text-xs'}>
                            <span>
                              <Toilet/>
                            </span>
                            <span>{propertyDetails?.property?.toilets}</span>
                          </span>
                            <span
                              className={`${propertyDetails?.property?.status === 0 ? 'text-red-600' : 'text-green-600'} uppercase bg-custom-grey font-semibold rounded-full text-xxs md:text-xs py-1 px-1.5 md:py-2 md:px-4 `}>
                              {propertyDetails?.property?.status === 0 ? 'Not Available' : 'Active'}
                            </span>
                          </div>
                        </div>
                        <div className={'border-t border-custom-grey flex-col flex gap-y-6'}>
                          <div className={'flex flex-col gap-y-2.5'}>
                            <div className={'flex gap-2 text-xl font-semibold items-center py-3'}>
                              <PropertyOverview/>
                              <p>Property Overview</p>
                            </div>
                            <div className={'px-1'}>
                              <p
                                className='text-xxs md:text-xs lg:text-sm break-words'
                                dangerouslySetInnerHTML={{ __html: propertyDetails?.property?.details }}
                              />
                            </div>
                          </div>
                          <div className={'flex flex-col gap-2.5'}>
                            <p className={'text-xl font-semibold'}>Have more questions about this property?</p>
                            <div className={'flex gap-3'}>
                              <img src={Support} alt={'support'} className={'h-[15%] w-[15%]'}/>
                              <div className={'font-light text-xs flex flex-col gap-y-2'}>
                                <p>
                                  Contact our real estate experts
                                </p>
                                <div onClick={() => setIsOpen(true)} className={'flex cursor-pointer justify-center w-fit px-4 gap-2 items-center border rounded-xl py-2'}>
                                  <MessageText1 size="15" color="#003D20" variant="Bold"/>
                                  <span>Message Us</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={'md:w-[35%] w-full px-5 py-2 pt-28 pb-14 rounded-2xl bg-white flex-col justify-center flex items-center h-fit gap-y-14'}>
                        <div className={'flex flex-col gap-y-2.5 w-full'}>
                          <p className={'text-center'}>
                            {propertyDetails?.property?.property_type === 'Mortgage' ?  'Property Price'  : 'Rent Amount'}
                          </p>
                          <p className='font-bold text-sm text-center md:text-xl xl:text-3xl lg:text-2xl'>{formatCurrency(Number(propertyDetails?.property?.fixed_amount))}</p>
                        </div>
                        <div className={'w-full flex flex-col gap-y-5'}>
                          {
                            propertyDetails?.property?.status === 1 ?
                              <div onClick={buySlot}
                                   className={` cursor-pointer rounded-xl w-[60%] mx-auto text-center text-white font-semibold py-2.5 px-8 ${propertyDetails?.property?.available_slots === 0 ? 'hidden' : propertyDetails?.inspection_status === 'pending' ? 'bg-custom-grey' : 'bg-custom-lemongreen'}`}>
                                {getButtonName(propertyDetails?.inspection_status)}
                              </div> : null
                          }

                        </div>
                      </div>
                    </div>
                    <ContactUs isOpen={isOpen} onHide={() => setIsOpen(false)} />
                    <BookInspection isOpen={isInspectionOpen} onHide={onHideBookInspection}
                                    propertyId={pageName} />
                    <RentAssist isOpen={isRentAssistOpen} onHide={() => setIsRentAssistOpen(false)}
                                amount={propertyDetails?.property?.fixed_amount} propertyId={pageName} getFrameLink={getFrameLink} />
                    <PaymentFrame isOpen={isPaymentFrameOpen} onHide={() => setIsPaymentFrameOpen(false)} src={link} verify={function (): void {
                      throw new Error('Function not implemented.');
                    } } />
                  </div>
                </>
            }
          </div>
        </div> :
        <BuyProperty investmentDetails={datata.current} onHide={() => setBuy(false)}/>}
    </div>
  );
}

export default Viewproperty;
